
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/faq/[id]",
      function () {
        return require("private-next-pages/support/faq/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/faq/[id]"])
      });
    }
  